export var POINTS_IN_ONE_DOLLAR = 80;
export var POINTS_MAX_GIVE_TO_OTHER_DEVIANT_VALUE = 3500;
export var pointsToDollars = function (points) {
    return (points / POINTS_IN_ONE_DOLLAR).toFixed(2);
};
export var dollarsToPoints = function (dollars) {
    return Math.floor(dollars * POINTS_IN_ONE_DOLLAR);
};
//# sourceMappingURL=points.js.map